function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M66.6113 223.491C67.5305 219.354 61.708 205.872 59.0269 200.51L67.7603 198.786C68.9094 201.084 70.0584 205.106 71.2074 207.979C71.8902 209.686 75.4206 212.958 77.5272 214.298C73.5055 219.086 65.692 227.627 66.6113 223.491Z",
  fill: "#EC404A",
  stroke: "#4D46FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M102.117 228.086C101.661 226.785 95.2224 218.702 92.9243 214.872L99.8186 210.851L103.266 216.021L111.425 220.618L104.53 236.704C102.424 235.747 104.53 234.981 102.117 228.086Z",
  fill: "#EC404A",
  stroke: "#4D46FF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M75.2295 106.287V102.84L94.1888 96.5205L105.679 101.691V106.287L82.1238 109.735L75.2295 106.287Z",
  fill: "#EC404A"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M114.298 127.545C117.238 116.273 109.51 108.011 105.105 104.564C85.3414 109.16 76.9534 107.628 75.2298 106.288C68.3968 116.936 70.701 119.24 69.4847 125.821C59.3347 136.929 38.6901 160.867 37.3113 167.762C35.9324 174.656 47.8442 193.232 53.9725 201.659C61.786 203.037 67.5696 199.552 69.4847 197.637L58.453 177.529C58.453 177.529 55.8353 172.959 59.1432 167.762C61.085 164.711 66.8258 162.591 66.8258 162.591C64.5119 168.144 62.6796 173.303 62.0157 176.954C60.1772 187.066 76.9534 206.446 85.5712 214.873V217.171C95.2232 217.63 100.317 212.766 101.658 210.276L85.5712 182.699V179.252H80.975L85.5712 176.954C94.9551 161.25 110.85 140.759 114.298 127.545Z",
  fill: "#4D46FF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5275 45.3873L32.7199 57.4523L32.5988 64.3467L24.1016 60.8994C21.8035 56.8778 17.0924 48.6046 16.6328 47.6854C16.0583 46.5363 9.16475 39.642 8.59002 39.0675C8.13023 38.6079 7.63198 36.9609 8.01514 36.1949C4.95101 34.4713 0.197558 30.6801 1.11573 29.3006C1.32083 28.9924 1.69452 27.7685 4.56722 30.4496C1.6946 27.577 1.42725 26.6907 1.6901 26.4279C2.26463 25.8534 2.84365 26.2364 3.41817 26.4279L10.3135 31.5987C12.2285 33.8968 16.5183 38.8377 18.3568 40.2166C20.1953 41.5954 22.57 44.2382 23.5275 45.3873Z",
  fill: "#EC404A",
  stroke: "#FF9BFF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.1377 30.4502C5.1377 31.4077 5.59731 33.5526 7.43579 34.4719C9.27427 35.3911 10.8829 36.77 11.4575 37.3445C11.266 38.4935 11.6873 41.3662 14.9046 43.6643",
  stroke: "#EC404A",
  strokeWidth: 1.15207
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M170.026 63.1982C172.899 62.2407 178.644 60.6703 178.644 62.0491C178.644 63.428 175.771 63.7727 175.771 63.7727C175.771 63.7727 171.635 64.5771 171.175 65.4963C170.715 66.4156 172.899 66.6454 174.048 66.6454",
  stroke: "black",
  strokeWidth: 1.15207
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M155.088 71.2413C157.578 70.0923 164.051 66.9899 165.43 66.0707C167.153 64.9216 169.451 60.8999 171.175 60.3254C172.554 59.8658 175.58 58.6019 176.92 58.0273C176.92 58.0273 183.815 57.4528 183.815 58.0273C183.815 58.6019 182.474 58.9849 181.517 59.1764C180.746 59.3304 179.283 59.6083 178.5 59.7112C180.117 59.6037 185.538 59.3753 185.538 60.3254C185.538 61.4745 182.764 60.8014 182.091 61.4745C181.867 61.6988 184.964 62.049 184.389 62.6235C183.815 63.198 182.556 63.0088 182.091 63.198C181.234 63.5471 183.623 64.1556 183.24 64.3471C182.857 64.5386 178.849 64.5105 178.644 64.9216C178.069 66.0707 174.048 67.2197 171.75 68.9433C171.382 69.2191 164.548 74.88 161.293 76.9866H155.088V71.2413Z",
  fill: "#EC404A",
  stroke: "#FF9BFF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M65.4627 233.257C65.9224 231.878 65.2712 224.639 64.8882 221.192C66.0372 221.384 69.0247 221.307 71.7824 219.469C74.5402 217.63 74.8466 213.724 74.6551 212C74.8466 210.851 74.6551 210.276 75.8041 210.276C77.6209 210.276 79.8258 213.149 82.1239 214.298C83.9624 215.217 83.656 217.362 83.2729 218.32L66.6118 242.45C62.0156 242.909 61.6326 239.96 62.0156 238.428C62.9731 237.279 65.0031 234.636 65.4627 233.257Z",
  fill: "black",
  stroke: "black",
  strokeWidth: 1.15207
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M64.3135 242.449L82.6983 215.447",
  stroke: "#EC404A",
  strokeWidth: 1.15207
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M114.872 214.872L104.531 216.596C109.127 220.617 107.403 227.512 106.254 229.81C105.335 231.648 102.424 232.874 101.083 233.257C103.382 236.704 108.093 244.403 108.552 247.62C109.012 250.837 112.957 250.11 114.872 249.344C116.251 247.965 116.213 243.024 116.021 240.726C115.83 234.406 115.562 221.307 116.021 219.468C116.481 217.63 115.447 215.638 114.872 214.872Z",
  fill: "black",
  stroke: "black",
  strokeWidth: 1.15207
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M113.148 249.918L112.574 214.872",
  stroke: "#EC404A",
  strokeWidth: 1.15207
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M76.3784 110.883V124.672L78.6765 127.545L76.3784 133.29",
  stroke: "#EC404A",
  strokeWidth: 1.15207
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M75.2295 110.884C82.1238 112.033 96.8316 110.539 100.509 109.16C104.186 107.781 106.254 106.671 106.828 106.288",
  stroke: "#EC404A",
  strokeWidth: 1.15207
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 86.0299,
  cy: 24.13,
  r: 24.13,
  fill: "#4D46FF"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M103.381 52.8567C107.02 52.4737 114.119 55.9626 117.36 58.1801C128.304 65.6686 130.636 80.6486 140.977 81.7977L155.663 70.667C155.663 72.3906 156.008 75.9526 157.386 76.4122C158.765 76.8718 161.408 76.6037 162.557 76.4122C157.195 84.6471 146.179 96.0489 136.129 93.0734C121.392 88.7101 113.149 73.1348 112.175 78.3414C110.628 86.6145 104.117 93.3441 106.415 103.111C104.691 100.238 101.5 99 86.7199 100.542C71.914 102.087 76.1472 104.564 75.1138 105.138C71.2766 93.3184 74.6164 91.9274 74.1568 88.7101C73.0078 87.944 65.8073 83.881 67.1862 79.2848C68.4783 74.9777 71.9561 71.8477 72.2308 71.7863C71.8431 70.7362 70.943 74.574 55.58 78.7103C40.6423 82.7319 26.2033 69.7094 24.0967 60.9001C25.2457 61.0916 27.8885 61.2448 29.2674 60.3255C30.6463 59.4063 32.14 57.2614 32.7145 56.3039C34.8211 59.1765 46.6456 66.4959 49.8347 66.0707C58.4526 64.9217 65.3493 57.428 76.2628 56.8783C80.3475 56.6726 82.8897 58.4105 86.7199 57.4529L103.381 52.8567Z",
  fill: "#FF9BFF"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M102.344 52.7724C99.792 51.5862 96.3179 47.8299 94.8999 46.1001C93.4987 47.1113 90.0515 49.9839 87.9969 51.9872C88.0339 53.4604 88.5578 55.8758 87.9969 58.6018C84.017 77.944 105.535 54.2551 102.344 52.7724Z",
  fill: "#EC404A"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M65.5 164.5C68.5641 156.457 77.7573 137.656 83.2727 132.141C81.8939 131.681 78.102 133.098 76.3784 133.864L71.2077 127.544",
  stroke: "#EC404A",
  strokeWidth: 1.15207
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M83.8475 110.883C83.656 113.564 84.7668 118.927 90.7418 118.927C96.7169 118.927 98.9765 118.544 99.3594 118.352",
  stroke: "#EC404A",
  strokeWidth: 1.15207
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M97.6358 109.734C98.7848 113.947 100.853 123.293 99.9339 126.97C99.0146 130.647 82.6981 160.292 74.6548 174.655C73.6973 175.421 72.012 177.183 72.9312 178.102C73.8505 179.022 75.9955 179.634 76.9531 179.826L76.3786 183.273L78.1022 183.848L94.7634 216.021",
  stroke: "#EC404A",
  strokeWidth: 1.15207
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M76.9529 141.333L48.8012 166.038C48.0351 166.804 46.7329 169.14 47.6521 172.358C48.5713 175.575 57.1121 193.041 60.1763 201.659",
  stroke: "#EC404A",
  strokeWidth: 1.15207
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M96.4868 86.7532C92.8098 89.0513 87.6774 87.7108 85.5708 86.7532C87.0472 88.1688 90.4 91 92 91C93.6 91 100.637 84.7217 103.956 81.5825C102.232 82.5401 102.807 82.8034 96.4868 86.7532Z",
  fill: "#EC404A",
  stroke: "#EC404A",
  strokeWidth: 1.15207,
  strokeLinecap: "round"
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  cx: 77.9865,
  cy: 49.4093,
  r: 5.18433,
  stroke: "#FF9BFF",
  strokeWidth: 1.12183
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M74.8299 39.3168C74.8299 39.3168 74.8291 39.3167 73.9658 37.3445C73.1024 35.3722 80.8592 20.6829 93.1702 35.0146C94.6673 33.5806 96.1645 34.6561 96.9131 35.7317C97.5119 36.5921 96.3714 39.0677 95.4159 38.5997L94.6478 41.9403L95.2223 46.5365C94.349 48.4486 92.3095 50.9429 90.9244 52.2232C87.7535 55.1544 84.8809 53.4308 84.8809 53.4308C84.8809 53.4308 79.233 48.8319 76.8375 47.1111C73.8432 44.96 75.9528 41.8264 75.9528 40.7508C75.9528 39.8904 75.2042 39.4363 74.8299 39.3168Z",
  fill: "#EC404A"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M83.1574 37.3448L82 37C83.8385 35.1615 86.4131 34.4722 87.7536 34.4722C87.5621 34.4722 86.8344 34.5871 85.4555 35.0467C84.0767 35.5063 83.3489 36.7703 83.1574 37.3448Z",
  fill: "black"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M74.5396 38.4938H79.1357C79.3273 38.4938 79.8252 38.7236 80.2848 39.6429L81.0695 43.2034M82 37L83.1574 37.3448C83.3489 36.7703 84.0767 35.5063 85.4555 35.0467C86.8344 34.5871 87.5621 34.4722 87.7536 34.4722C86.4131 34.4722 83.8385 35.1615 82 37Z",
  stroke: "black",
  strokeWidth: 1.15207,
  strokeLinecap: "round"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M82.5828 49.4091C81.6635 48.9495 82.1997 48.4516 82.5828 48.2601L86.6046 47.6855C86.4131 48.0686 85.9152 48.9495 85.4556 49.4091C84.8811 49.9836 83.7318 49.9836 82.5828 49.4091Z",
  fill: "#4D46FF"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M78.4153 31.1298C77.6379 33.7757 73.0753 37.3453 71.4652 38.0698C71.702 34.5466 73.6282 27.4477 79.4382 27.2387C85.2482 27.0296 87.5663 30.8245 87.9991 32.7482C84.5236 33.1641 79.5395 32.0589 78.4153 31.1298Z",
  fill: "#FF9BFF"
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  cx: 99.818,
  cy: 42.5153,
  r: 5.18433,
  stroke: "#FF9BFF",
  strokeWidth: 1.12183
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M71.7462 41.223C72.507 42.2624 73.563 44.4904 71.7011 45.0869C69.3737 45.8326 70.4432 42.4959 68.628 43.5052C66.8128 44.5145 69.8859 46.0962 68.0707 47.1055C66.2555 48.1148 71.3923 49.463 68.8014 50.7209",
  stroke: "#4D46FF",
  strokeWidth: 1.15207
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M113.396 37.9576C112.409 38.7856 110.256 39.9869 109.538 38.1687C108.639 35.8958 112.039 36.7419 110.912 34.9976C109.785 33.2532 108.41 36.4244 107.283 34.6801C106.155 32.9357 105.151 38.1506 103.724 35.6487",
  stroke: "#4D46FF",
  strokeWidth: 1.15207
});

function SvgDancing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 251,
    viewBox: "0 0 187 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDancing);
export default __webpack_public_path__ + "static/media/dancing.2d5a85f7.svg";
export { ForwardRef as ReactComponent };